import React from 'react';
import { Link } from 'react-router-dom';
import { FaPhone, FaEnvelope, FaArrowRight } from 'react-icons/fa';
import '../styles/ContactCTA.css';

const ContactCTA = () => {
  return (
    <section className="contact-cta">
      <div className="contact-cta-bg">
        <img
          src="/images/ready-to-connect.png"
          alt="Happy professionals collaborating"
          className="contact-cta-bg-img"
        />
      </div>
      <div className="container">
        <div className="contact-cta-content">
          <h2>Ready to Connect with Us?</h2>
          <p>
            Whether you're looking to hire exceptional talent or seeking your next career opportunity,
            we're here to help. Get in touch with our team today.
          </p>
          <div className="contact-info">
            <a href="tel:+16476849045" className="contact-item">
              <FaPhone />
              <span>+1 647-684-9045</span>
            </a>
            <a href="mailto:info@joywcs.com" className="contact-item">
              <FaEnvelope />
              <span>info@joywcs.com</span>
            </a>
          </div>
          <Link to="/contact" className="btn btn-light">
            Contact Us <FaArrowRight className="btn-icon" />
          </Link>
        </div>
      </div>
    </section>
  );
};

export default ContactCTA;
